import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: center;
  max-width: 10rem;
`
export const CheckBox = styled.div`
  .container {
    --input-focus: #003e5f;
    --input-out-of-focus: #ccc;
    --bg-color: #fff;
    --bg-color-alt: #666;
    --main-color: #494949;
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 1rem;

    > span {
      color: #494949;
    }
  }
  input:checked ~ .checkmark {
    background-color: var(--input-focus);
  }

  .container input {
    position: absolute;
    opacity: 0;
  }

  input:checked ~ .checkmark:after {
    display: block;
  }

  .checkmark {
    display: flex;
    flex-direction: row;
    width: 1.5rem;
    height: 1.5rem;
    position: relative;
    top: 0;
    left: 0;
    border: 2px solid var(--main-color);
    border-radius: 5px;
    box-shadow: 1px var(--main-color);
    background-color: var(--bg-color);
    transition: all 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px; /* Padding para alinhar o texto dentro do checkbox */
  }

  .container input:checked ~ .checkmark {
    background-color: var(--bg-color); /* Cor de fundo quando marcado */
    border-color: var(--input-focus); /* Cor do marcador quando marcado */
  }

  .checkmark:after {
    content: '';
    width: 7px;
    height: 13px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
    border: solid var(--input-focus);
    border-width: 0 2.5px 2.5px 0;
    display: none;
  }

  .container input:checked ~ .checkmark:after {
    display: block;
  }
`
